// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 932) return "static/chunks/932-a9af6bb958dc5a8d.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"2d5bdc710dfd360f","298":"3c17f9a45cf5b456","340":"9af45d93ca8e6e2c","367":"94760474698692b4","639":"662b2e7c337118a6","748":"c1992466dd336b82"}[chunkId] + ".js";
};